/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { UserInteractionInstrumentation } from './instrumentation';
export { AttributeNames } from './enums/AttributeNames';
export type {
  EventName,
  ShouldPreventSpanCreation,
  UserInteractionInstrumentationConfig,
} from './types';
